/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { api } from "@/services";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import qs from "qs";

const BASE = "/home";

const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

/** GET /home */
export async function showHome(savedFilter?: any) {
  const isActive =
    savedFilter?.$$filter?.id && savedFilter.$$filter.id !== "1";

  const params = isActive
    ? { filter: { $$filter: { id: savedFilter.$$filter.id, params: savedFilter.$$filter.params } } }
    : undefined;

  const { data } = await api.get<any>(BASE, {
    params,
    paramsSerializer: params ? serialize : undefined,
  });
  return data;
}

/** GET /home/pathologies-summary?months=N */
export async function getPathologiesSummary(months: number) {
  const { data } = await api.get<{
    summary: { month: string; critical: number; medium: number; low: number; totalItems: number }[];
    totalItems: number;
  }>(`${BASE}/pathologies-summary`, { params: { months } });
  return data;
}

export function usePathologiesSummaryQuery(months: number) {
  return useQuery({
    queryKey: ["pathologies-summary", months],
    queryFn: () => getPathologiesSummary(months),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/* ===== Query Keys ===== */
export const homeKeys = {
  all: ["home"] as const,
};

/* ===== Hook (React Query) ===== */
export function useHomeQuery(opts?: { enabled?: boolean; staleTimeMs?: number; savedFilter?: any }) {
  const { enabled = true, staleTimeMs = 10 * 60 * 1000, savedFilter } = opts ?? {};

  const filterKey = savedFilter?.$$filter?.id && savedFilter.$$filter.id !== "1"
    ? { id: savedFilter.$$filter.id, params: savedFilter.$$filter.params ?? null }
    : null;

  return useQuery({
    queryKey: filterKey ? [...homeKeys.all, filterKey] : homeKeys.all,
    queryFn: () => showHome(savedFilter),
    staleTime: staleTimeMs,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled,
  });
}

/* ===== Prefetch (opcional) ===== */
export function prefetchHome(qc: ReturnType<typeof useQueryClient>, staleTimeMs = 10 * 60 * 1000) {
  return qc.prefetchQuery({
    queryKey: homeKeys.all,
    queryFn: showHome,
    staleTime: staleTimeMs,
  });
}
